// src/pages/blackFriday/campanha.js — a campanha da Black Friday (out/26).
//
// Fonte única do que a faixa da landing (landing/FaixaBlackFriday.js) e o
// cadastro do PLUS (blackFriday/CadastroPlus.js) mostram: a chave que liga e
// desliga a campanha e a contagem.
//
// A contagem é um CICLO de 72 h, igual pra todo visitante, contado a partir
// de 26/10/2026 00:00 de Brasília: zerou, recomeça. Não termina sozinha — foi
// a escolha do dono (out/26), avisado de que uma contagem que reinicia pode
// ser lida como urgência falsa (CDC art. 37). Acabou a campanha:
// CAMPANHA_LIGADA = false — a faixa some da landing (sem deixar a altura no
// topo) e /register?plan=plus volta ao cadastro comum, com o card do Plus.
//
// A fonte "derrete" ao longo do ciclo: Climate Crisis (OFL), eixo YEAR de
// 1979 (inteira) a 2012 (ainda legível). fonts/ClimateCrisis-BlackFriday.woff2
// é um recorte dela — só maiúsculas, números, "$" e a pontuação dos títulos,
// eixo cortado em 2012 —, 19 KB no lugar dos 3,6 MB do original (licença OFL
// em fonts/). Letra nova num título em Climate Crisis = recortar de novo,
// senão cai na Syne. Declarada uma vez só, em fonte.css (importada aqui).
import { useEffect, useState } from 'react';
import './fonte.css';

export const CAMPANHA_LIGADA = true;

const ANCORA = Date.UTC(2026, 9, 26, 3, 0, 0); // 26/10/2026 00:00 em Brasília (UTC−3)
const CICLO_MS = 72 * 3600 * 1000;
const ANO_INICIO = 1979;
const ANO_FIM = 2012; // até onde a fonte derrete no fim do ciclo, ainda legível

// Mesma conta do design: o que falta pro fim do ciclo atual e o "ano" da fonte.
export function contagem(agora) {
  const passou = (((agora - ANCORA) % CICLO_MS) + CICLO_MS) % CICLO_MS;
  const resta = Math.floor((CICLO_MS - passou) / 1000);
  return {
    d: Math.floor(resta / 86400),
    h: Math.floor((resta % 86400) / 3600),
    m: Math.floor((resta % 3600) / 60),
    s: resta % 60,
    ano: Math.round(ANO_INICIO + (passou / CICLO_MS) * (ANO_FIM - ANO_INICIO)),
  };
}

// A contagem andando, um quadro por segundo.
export function useContagem() {
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setAgora(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  return contagem(agora);
}

export const dois = (n) => String(n).padStart(2, '0');

// O que o leitor de tela ouve: muda de minuto em minuto, sem os segundos.
export const rotuloContagem = ({ d, h, m }) => `A oferta termina em ${d} dias, ${h} horas e ${m} minutos`;
